import { useState, type FormEvent } from 'react';

interface HomeComposerProps {
  onSubmit: (message: string) => void;
  disabled?: boolean;
}

export default function HomeComposer({ onSubmit, disabled = false }: HomeComposerProps) {
  const [message, setMessage] = useState('');
  const trimmedMessage = message.trim();
  const submitDisabled = !trimmedMessage || disabled;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (submitDisabled) {
      return;
    }
    onSubmit(trimmedMessage);
  };

  return (
    <form
      className="home-composer"
      onSubmit={handleSubmit}
      style={{
        width: 'min(760px, 100%)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        background: 'var(--surface-card)',
        borderRadius: 'var(--radius-pill)',
        boxShadow: 'var(--shadow-float)',
        padding: '10px 10px 10px 28px',
      }}
    >
      <input
        type="text"
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        placeholder="Spørg om matematik, fysik, kemi eller biologi"
        aria-label="Spørg om matematik, fysik, kemi eller biologi"
        disabled={disabled}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          background: 'transparent',
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--text-lg)',
          color: 'var(--text-heading)',
          minWidth: 0,
        }}
      />
      <button
        type="submit"
        disabled={submitDisabled}
        aria-label="Send spørgsmål"
        style={{
          width: 52,
          height: 52,
          flexShrink: 0,
          borderRadius: '50%',
          border: 'none',
          background: 'var(--blue-600)',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: submitDisabled ? 'default' : 'pointer',
          opacity: submitDisabled ? 0.55 : 1,
        }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M12 19V5" />
          <path d="m5 12 7-7 7 7" />
        </svg>
      </button>
    </form>
  );
}
